import { Modal, ModalDialog, RadioGroup, Radio, Button } from "@mui/joy";
import React, { useEffect, useState } from "react";
import { postFetch } from "../../../../../../fetch/fetch";


const EmploymentInsuranceModal: React.FC<any> = (props) => {

    const [selected, setSelected] = useState<string>("no");
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {

        if (props.open) {
            setSelected(props.employmentInsurance ? "yes" : "no");
        }

    }, [props.open, props.employmentInsurance]);

    const submit = async () => {

        try {

            if (!props.user) {
                return;
            }

            setLoading(true);

            const isApplied = selected === "yes";

            const result: any = await postFetch("/dashboard/salary/setemploymentinsurance", {
                userId: props.user.id,
                isApplied,
            });

            if (result.message === "success") {
                props.setEmploymentInsurance(isApplied);
                props.notify("success", "고용보험 설정이 저장되었습니다.");
                props.onClose();
            }

            setLoading(false);

        } catch (e) {
            console.log(e);
        }

    }

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
        >
            <ModalDialog>
                <div style={{ width: "280px" }}>
                    <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "18px" }}>
                        고용보험 포함여부 선택
                    </div>
                    <div style={{ fontWeight: 600, marginBottom: "9px" }}>
                        적용 여부
                    </div>
                    <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "10px", lineHeight: 1.5 }}>
                        직원관리 &gt; 직원명부의 고보 값과 연동됩니다. 여기서 바꾸면 명부의 재직 파트 고보도 같이 바뀝니다 (해당X 는 유지).
                    </div>
                    <RadioGroup
                        orientation="horizontal"
                        value={selected}
                        onChange={(e: any) => setSelected(e.target.value)}
                    >
                        <Radio value="no" label={<span>비적용</span>} />
                        <Radio value="yes" label={<span>적용</span>} />
                    </RadioGroup>
                    <div style={{ marginTop: "25px" }}>
                        <Button
                            variant="solid"
                            fullWidth
                            onClick={submit}
                            loading={loading}
                        >
                            제출하기
                        </Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );

}

export default EmploymentInsuranceModal;
